import { actions, getAllUsersAsync } from './slices';

export const UsersActions = {
  ...actions,
  getAllUsersAsync,
};
